import styled from 'styled-components';
import { ResetSolid } from '@simplywallst/ui-core/icons';

export type ColorTheme = 'light' | 'dark';

interface Theme {
  color?: ColorTheme;
}

export const SearchSpinner = styled('div')`
  width: ${({ theme }) => theme.x2spacePx}px;
`;

export const ResetIcon = styled(ResetSolid)<Theme>`
  opacity: 0.5;
  > path {
    fill: ${({ theme, color }) =>
      color === 'dark' ? theme.color.whiteRGBA(0.7) : theme.color.white};
  }
`;
